import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20romantic%20illustration%20background%20with%20subtle%20floating%20heart%20shapes%20and%20gentle%20gradients%20in%20warm%20peach%20and%20soft%20pink%20tones%20dreamy%20bokeh%20effect%20minimalist%20abstract%20composition%20clean%20no%20characters%20no%20text&width=1920&height=500&seq=cta-bg-manga-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-white mb-4">
          准备好开始你的<strong>漫画之旅</strong>了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          海量<strong>无删减韩国漫画</strong>等你来探索，<strong>下拉式阅读</strong>体验，即刻开启甜蜜剧情
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/korean-romance"
            className="px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            浏览韩国恋爱漫画
          </Link>
          <Link
            to="/category/completed"
            className="px-8 py-3.5 text-sm font-semibold rounded-full bg-white/20 text-white hover:bg-white/30 border border-white/30 transition-all whitespace-nowrap"
          >
            查看已完结作品
          </Link>
        </div>
      </div>
    </section>
  );
}